var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscontinuedMedication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.613409548,9.32321065 L6.93662169,9.32321065 C7.21276406,9.32321065 7.43662169,9.54706827 7.43662169,9.82321065 L7.43662169,10.8470194 C7.43662169,11.1231618 7.21276406,11.3470194 6.93662169,11.3470194 L0.613409548,11.3470194 C0.337267173,11.3470194 0.113409548,11.1231618 0.113409548,10.8470194 L0.113409548,9.82321065 C0.113409548,9.54706827 0.337267173,9.32321065 0.613409548,9.32321065 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-68.3%",
    y: "-197.6%",
    width: "236.6%",
    height: "594.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0235294118   0 0 0 0 0.615686275   0 0 0 0 0.870588235  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.95629369,4.90611618 C7.27515549,3.30309533 8.13527453,2.51999488 9.5366508,2.55681482 C11.0454267,2.74843103 11.9526184,3.75147788 12.2582258,5.56595539 L12.2629897,9.31012082 L8.41269241,9.30728089 C7.90516495,9.49695981 7.64899995,9.78786077 7.64419742,10.1799837 C7.63699362,10.7681682 8.23545278,11.0617934 8.47925556,11.089824 C9.47004486,11.0889707 10.7281302,11.0861348 12.2535117,11.0813164 L12.2355895,14.2707781 C11.7667591,16.1545866 10.9016972,17.1009303 9.64040369,17.1098091 C7.74846344,17.1231274 6.99460561,15.7769288 6.96193706,15.3284137 C6.88142543,14.4793906 5.46449903,14.1361821 5.18575718,15.4152927 C5.20466152,17.0729083 6.40547764,17.9629367 7.55755356,18.6357577 C8.70962948,19.3085787 13.7450254,19.4662353 13.9499165,14.0682917 C13.9988554,10.778965 14.0405015,7.91692806 14.0748549,5.48218087 C13.5726548,2.50628738 12.0077655,0.941398137 9.38018718,0.787513141 C6.20749966,0.716694408 4.99472996,3.66952269 4.96963367,4.72353589 C4.98609741,4.78948759 4.76853856,6.4668652 4.79832835,7.85508331 C4.81371258,8.57199532 5.54480618,8.83152444 5.78910777,8.84586273 C6.04935527,8.8611369 6.72744829,8.62425851 6.77655134,7.67113982 C6.80190464,7.1790176 6.86181875,6.25734305 6.95629369,4.90611618 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-53.9%",
    y: "-22.0%",
    width: "207.8%",
    height: "155.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0235294118   0 0 0 0 0.615686275   0 0 0 0 0.870588235  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-button-tertiary",
    transform: "translate(-12.000000, -12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notifications"
  }, /*#__PURE__*/React.createElement("g", {
    id: "medication-icon",
    transform: "translate(9.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    transform: "translate(12.166709, 12.033371) rotate(-45.000000) translate(-12.166709, -12.033371) translate(4.666709, 2.533371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-4",
    transform: "translate(3.775016, 10.335115) rotate(-135.000000) translate(-3.775016, -10.335115) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#208CFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#208CFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscontinuedMedication);
export default __webpack_public_path__ + "static/media/discontinuedMedication.d0942ff2405abb735dfefb429d30cbd7.svg";
export { ForwardRef as ReactComponent };